import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { Language } from './language.model';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private apiUrl = environment.apiEndpoint + 'languages';

  constructor(private http: HttpClient) {}

  getLanguages(params = {}): Observable<any> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<Language[]>(this.apiUrl, { params: queryParams });
  }

  changeDefaultLanguage(language: Language): Observable<Language> {
    let body = {
      is_default: !language.is_default,
    };

    return this.http.put<Language>(`${this.apiUrl}/${language.id}`, body);
  }
}
